// in src/MyLayout.js
import * as React from 'react';
import { Layout } from 'react-admin';
import NmsAppBar from './NmsAppBar';
import './NmsLayout.css';

const NmsLayout = (props) => <Layout {...props} appBar={NmsAppBar} />;

export default NmsLayout;
